import { createSlice } from "@reduxjs/toolkit";
import { getUpdateCuisenStatusAPI } from "../../api/cuisine";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getUpdateCuisenStatusSlice = createSlice({
  name: "getUpdateCuisenStatus",
  initialState: data,
  reducers: {
   getUpdateCuisenStatusSlice(state) {
      state.isLoading = true;
    },
   getUpdateCuisenStatusSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getUpdateCuisenStatusSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getUpdateCuisenStatusSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getUpdateCuisenStatusHandler = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(getUpdateCuisenStatusAction.getUpdateCuisenStatusSlice());
    const response: any = await getUpdateCuisenStatusAPI(id,data);
    
    dispatch(getUpdateCuisenStatusAction.getUpdateCuisenStatusSliceSuccess(response));
  } catch (e: any) {
    dispatch(getUpdateCuisenStatusAction.getUpdateCuisenStatusSliceFailure(e?.response?.data));
  }
};
export default getUpdateCuisenStatusSlice.reducer;
export const getUpdateCuisenStatusAction = getUpdateCuisenStatusSlice.actions;
